// extracted by mini-css-extract-plugin
module.exports = {"root":"Group-root-d413367d5b3d46e3daf4fc7d558d890f","title":"Group-title-c8e703722d7582b958c5cbe39356ecb7","light":"Group-light-53d8108fbd4e63e2db4eba5c2b0d0e2f"};